import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../api/$api";
import {
  TDataToken,
  TQueries,
  TCreateTemplatePayload,
  TUpdateTemplatePayload,
  TDeleteTemplatePayload,
} from "./type";


// get all templates
export const getTemplates = (data: TDataToken, queries: TQueries) => {
  return $api
    .get(`/template-details`, { token: data.accessToken, params: { ...queries } })
    .then((response) => {
      return response;
    });
};

export const useGetTemplates = (data: TDataToken, queries: TQueries, config?: {}) => {
  return  useQuery({
    queryKey: ["templates", queries],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getTemplates(data, queries),
    ...config as UseQueryOptions<any>
  });
};


// create template
export const createNewTemplate = (
  data: TDataToken,
  payload: TCreateTemplatePayload
) => {
  return $api
    .post(`/state/template`, { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateTemplate = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateTemplatePayload>
) => {
  return useMutation({
    mutationFn: (payload: TCreateTemplatePayload) => createNewTemplate(data, payload),
    ...config
  });
};

// update template
export const updateTemplate = (
  data: TDataToken,
  payload: TUpdateTemplatePayload
) => {
  return $api
    .put(`/state/template`, { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateTemplate = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateTemplatePayload>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateTemplatePayload) => updateTemplate(data, payload),
    ...config
  });
};


// delete template
export const deleteTemplate = (data: TDataToken, payload: TDeleteTemplatePayload) => {
  return $api
    .delete(`/state/template`, { data: { ...payload }, token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useDeleteTemplate = (data: TDataToken, config?: UseMutationOptions<any, unknown, TDeleteTemplatePayload>) => {
  return useMutation({
    mutationFn: (payload: TDeleteTemplatePayload) => deleteTemplate(data, payload),
    ...config
  });
};